import React from 'react'
import AppRouter from './AppRouter'
import { useConnectionStatus } from './hooks/useConnectionStatus'

const App: React.FC = () => {
  useConnectionStatus()

  return (
    <div className='min-h-screen flex flex-col justify-center'>
      <div className=''>
        <AppRouter />
      </div>
    </div>
  )
}

export default App
